import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogConfig as MatDialogConfig,
} from '@angular/material/legacy-dialog';
import { DialogSpinner } from './dialog-spinner/dialog-spinner.component';
import { Observable, Subject, takeUntil } from 'rxjs';
import { ToastrService } from '../services/toastr.service';
import { TranslateService } from '@ngx-translate/core';
import { DownloadService } from '../pages/full-pages/download-service/download.service';
import { Router } from '@angular/router';
import { AppService } from '../services/app.service';
import { Injectable, OnDestroy } from '@angular/core';
import { TipoRelatorio } from 'enums/tipo-relatorio';
import { AbReport } from 'app/abstract/commons/report.abstract';

const VINTE_SEGUNDOS = 20000;

@Injectable({ providedIn: 'root' })
export class ReportService extends AbReport implements OnDestroy {
  constructor(
    private toastr: ToastrService,
    private translate: TranslateService,
    private downloadService: DownloadService,
    private router: Router,
    private service: AppService,
    private dialog: MatDialog
  ) {
    super();
  }

  private readonly destroy$ = new Subject();

  public delay() {
    return new Promise((resolve) => setTimeout(resolve, VINTE_SEGUNDOS));
  }

  public async relatorioS3(
    tipoRelatorio: TipoRelatorio,
    tentativa: number = 0
  ) {
    if (!this.verificaRota(tipoRelatorio)) {
      this.toastr.on();
      return;
    }

    if (tentativa > 15) {
      this.toastr.on();
      this.toastr.warning(
        this.translate.instant('NAO_FOI_POSSIVEL_GERAR_RELATORIO')
      );
      this.hideProgressSpinner();
      return;
    }

    await this.delay();
    this.service
      .getRelatorioS3(tipoRelatorio.getNomeEnum())
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (rel: any) => {
          this.downloadService
            .downloadArquivoByBase64(rel.base64, rel.nomeRelatorio)
            .pipe(takeUntil(this.destroy$))
            .subscribe();
          this.hideProgressSpinner();
        },
        () => {
          this.relatorioS3(tipoRelatorio, ++tentativa);
        }
      );
  }

  public verificaRota(tipoRelatorio: TipoRelatorio) {
    return this.router.url.includes(tipoRelatorio.getRota());
  }

  public gerarRelatorio(
    consulta: Observable<any>,
    tipoRelatorio: TipoRelatorio
  ) {
    this.showProgressSpinner();
    this.toastr.off();
    consulta.pipe(takeUntil(this.destroy$)).subscribe(
      (data: any) => {
        this.downloadService
          .downloadArquivoByBase64(data.base64, data.nomeRelatorio)
          .pipe(takeUntil(this.destroy$))
          .subscribe();
        this.hideProgressSpinner();
      },
      (error: any) => {
        if (this.verificarRelatorioS3(error)) {
          this.relatorioS3(tipoRelatorio);
        } else {
          this.hideProgressSpinner();
          this.toastr.on();
          this.toastr.error(error);
        }
      }
    );
  }

  public verificarRelatorioS3(error: any): boolean {
    let status = error.status;
    return (
      status === 400 ||
      status === 406 ||
      status === 408 ||
      status === 504 ||
      this.isFailureResponse(error)
    );
  }

  public isFailureResponse(error: any): boolean {
    return (
      error?.status === 0 && error?.message?.includes('failure response for')
    );
  }

  public showProgressSpinner() {
    this.toastr.off();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      id: 1,
      msg: this.translate.instant('AGUARDE_RELATORIO'),
    };

    this.dialog.open(DialogSpinner, dialogConfig);
  }

  public hideProgressSpinner() {
    this.dialog.closeAll();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
